import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contex/AuthContext";

export default function ForgotPasswordScreen() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await resetPassword(email);
      setSent(true);
    } catch (err) {
      if (err.code === "auth/user-not-found") {
        setError("No account found with this email.");
      } else if (err.code === "auth/invalid-email") {
        setError("Please enter a valid email address.");
      } else {
        setError("Something went wrong. Please try again.");
      }
    }
    setLoading(false);
  };

  if (sent) {
    return (
      <div style={styles.wrap}>
        <div style={styles.icon}>📬</div>
        <div style={styles.title}>Check your inbox</div>
        <div style={styles.desc}>
          We sent a password reset link to:
        </div>
        <div style={styles.email}>{email}</div>
        <div style={styles.desc}>
          Click the link in the email to reset your password. Check your spam folder if you don't see it.
        </div>
        <Link to="/login" style={styles.link}>← Back to sign in</Link>
      </div>
    );
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.icon}>🔑</div>
      <div style={styles.title}>Forgot password?</div>
      <div style={styles.desc}>
        Enter your email address and we'll send you a link to reset your password.
      </div>

      <form onSubmit={handleReset} style={styles.form}>
        <div style={styles.group}>
          <label style={styles.label}>Email address</label>
          <input
            style={styles.input}
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>

        {error && <div style={styles.error}>{error}</div>}

        <button style={styles.primaryBtn} type="submit" disabled={loading}>
          {loading ? "Sending..." : "Send reset link"}
        </button>
      </form>

      <Link to="/login" style={styles.backLink}>← Back to sign in</Link>
    </div>
  );
}

const styles = {
  wrap:       { minHeight:"100vh", background:"#0F0F13", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:"32px 24px", textAlign:"center" },
  icon:       { fontSize:"48px", marginBottom:"16px" },
  title:      { fontSize:"26px", fontWeight:700, color:"#F0EFE8", letterSpacing:"-.5px", marginBottom:"10px" },
  desc:       { fontSize:"14px", color:"#9998A0", lineHeight:1.6, marginBottom:"10px", maxWidth:"320px" },
  email:      { fontSize:"15px", fontWeight:600, color:"#7C6EF8", marginBottom:"16px" },
  form:       { width:"100%", maxWidth:"360px", textAlign:"left" },
  group:      { marginBottom:"16px" },
  label:      { display:"block", fontSize:"12px", fontWeight:600, color:"#9998A0", textTransform:"uppercase", letterSpacing:".06em", marginBottom:"6px" },
  input:      { width:"100%", padding:"14px 16px", background:"#18181F", border:"1px solid rgba(255,255,255,0.13)", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", color:"#F0EFE8", outline:"none" },
  error:      { fontSize:"13px", color:"#F05D5D", marginBottom:"12px" },
  primaryBtn: { width:"100%", padding:"15px", background:"#7C6EF8", border:"none", borderRadius:"10px", fontFamily:"inherit", fontSize:"15px", fontWeight:600, color:"#fff", cursor:"pointer", marginBottom:"16px" },
  backLink:   { fontSize:"14px", color:"#9998A0", textDecoration:"none", marginTop:"8px" },
  link:       { fontSize:"14px", color:"#7C6EF8", textDecoration:"none", marginTop:"16px", display:"block" },
};